/**
* 基础菜单 商品管理
*/
<template>
  <div class="contianer">

  </div>
</template>

<script>
  export default {
    data: () => {
      return {

      }
    },
    // 公告弹窗
    mounted() {

    },
    destroyed() {
      clearTimeout(this.timer)
    },
    // 注册组件
    components: {},
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

    }
  }
</script>

<style scoped>
  .contianer {

  }
</style>





// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue